// extracted by mini-css-extract-plugin
export var wordContainer = "_m0-0";